module.exports = __webpack_public_path__ + "static/media/Jessie Chen.06ab794f.png";